var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsString } from 'class-validator';
import { OfficeLocationDatevSettingsResponseDto } from '../../office-location-datev-settings/dto/office-location-datev-settings.response.dto.js';
/**
 * Read shape for the public Steuerberater route — bundles the scoped
 * `OfficeLocationDatevSettings` with the minimal naming context the route
 * header needs ("Sie bearbeiten DATEV-Einstellungen für {officeLocationName}
 * im Auftrag von {officeName}").
 *
 * Intentionally narrow: only the two names, no addresses, no contact info,
 * no patient data — Art. 9 DSGVO + §203 StGB. The presence of
 * `OfficeLocationDatevSettings` is sanctioned because the entire purpose of
 * the route is to let the Steuerberater edit it.
 */
export class SteuerberaterPublicContextResponseDto {
    officeLocationName;
    officeName;
    datevSettings;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], SteuerberaterPublicContextResponseDto.prototype, "officeLocationName", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], SteuerberaterPublicContextResponseDto.prototype, "officeName", void 0);
__decorate([
    Expose(),
    Type(() => OfficeLocationDatevSettingsResponseDto),
    __metadata("design:type", OfficeLocationDatevSettingsResponseDto)
], SteuerberaterPublicContextResponseDto.prototype, "datevSettings", void 0);
//# sourceMappingURL=steuerberater-public-context.response.dto.js.map